import { render } from "./modal-download-failed.vue?vue&type=template&id=34c19ca1&scoped=true&ts=true"
import script from "./modal-download-failed.vue?vue&type=script&lang=ts"
export * from "./modal-download-failed.vue?vue&type=script&lang=ts"

import "./modal-download-failed.vue?vue&type=style&index=0&id=34c19ca1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c19ca1"]])

export default __exports__